/**
 * package: com.inq.stage
 * class: ViewportMgrImplPhoneAndroid
 * @extends com.inq.stage.ViewportMgrImplPhone 
 * @constructor
 */
com.inq.stage.ViewportMgrImplPhoneAndroid = function() {
	com.inq.stage.ViewportMgrImplPhone.call(this);
};
/* specify hierary; its parent is com.inq.stage.ViewportMgrImplPhone */
$hxClasses.extend(com.inq.stage.ViewportMgrImplPhone, com.inq.stage.ViewportMgrImplPhoneAndroid, 'com.inq.stage.ViewportMgrImplPhoneAndroid');


/** @private @type {Number} */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.uponResizeId = 0;
/** @const */
com.inq.stage.ViewportMgrImplPhoneAndroid.FIXED_CONTENT = "width=device-width, initial-scale=1.0, maximum-scale=1.0";
/** @const @type {Number} */
com.inq.stage.ViewportMgrImplPhoneAndroid.chatWindowZoomLevel = 1;


/**
 * calcPhoneWidth
 *
 * @private
 * @override
 * @this com.inq.stage.ViewportMgrImplPhoneAndroid
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.calcPhoneWidth = function() {
	if(this.phoneWidth == 0) {
		this.modifyViewport("width=device-width");
		/** @type {com.inq.ui.Stage} */ 
		var stage = com.inq.ui.Stage.getInstance();
		/** @type {Element} */ 
		var stageElement = com.inq.ui.Stage.getStageElement();
		/* Make sure that the stage renders filling the screen as fixed */
		Application.application.applyStyle();										
		this.phoneWidth = stageElement.offsetWidth;
	}
};

/**
 * fixedWidthViewport
 *
 * @private
 * @override
 * @this com.inq.stage.ViewportMgrImplPhoneAndroid
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.fixedWidthViewport = function() {
	this.modifyViewport("width=device-width, user-scalable=no");     // Android fix position support standard
	try {
		com.inq.ui.Container._getElementById("inqDivResizeCorner",parent.document).style.display = "";
	} catch (ex) { 	}
};

/**
 * uponResizeAction - this is to catch the resizing of the phone,
 *	- It was originally in the ChatTextFocusMonitor but was moved here because,
 *    it was turned off on blur and also should be controlled regardless of focus and blur.
 *  - Here we can catch screen resize for android phones, but we want to only resize to the viewport if the stage is visible,
 *    Otherwise we get shown after any screen resize.
 *
 * public static function uponResize(event:Event)
 * @public
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.uponResizeAction = function() {
	this.uponResizeId = 0;
	if (com.inq.ui.Stage.getInstance().getVisible()) {
		Application.SetArea(com.inq.utils.Capabilities.getViewport());
		com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
	}
};


/**
 * uponResize - to execute uponResizeAction this function schedules it and continue listen for resize event.
 *   if a new resize event is detected, cancel previous schedule and schedule it again.
 *   This is to execute uponResizeAction (handler) only once in a series of resize events after the last one.
 *
 * public static function uponResize(event:Event)
 * @public
 * @param {js.Event}  event
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.uponResize = function(event) {

	if (this.uponResizeId != 0) {
		window.clearTimeout(this.uponResizeId);
	}
	this.uponResizeId = com.inq.utils.Capabilities.waitFor(
		com.inq.utils.Capabilities.viewportStopsMoving(300),
		100,
		this.uponResizeAction
	);
};


/**
 * resizeToViewport
 *
 * On Android Phone device, you don't want to call com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewport().
 * This function takes minimum action to render chat window.
 *
 * @override
 * @this com.inq.stage.ViewportMgrImplPhoneAndroid
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.resizeToViewport = function() {

	com.inq.flash.client.chatskins.ScrollMonitor.unbindAll();

	/* Figure out the zoom level */
	if(com.inq.stage.ViewportMgrImplPhoneAndroid.chatWindowZoomLevel != Application.initialZoom) {
		Application.initialZoom = com.inq.stage.ViewportMgrImplPhoneAndroid.chatWindowZoomLevel;
		Application.application.setStyle("zoom","" + Application.initialZoom);
	}

	try {
		Application.SetArea(com.inq.utils.Capabilities.getViewport());
		Application.Resize();
	} catch (err) {
		haxe.Log.trace("Error: " + err, { fileName : "ViewportMgrImplPhoneAndroid.js", lineNumber : 111, className : "com.inq.stage.ViewportMgrImplPhoneAndroid", methodName : "resizeToViewport"});
	}

	com.inq.flash.client.chatskins.ScrollMonitor.bindAll();

};


/**
 * getChatWindowZoomLevel
 *
 * returns constant value of zoomlevel of Android Phone
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.getChatWindowZoomLevel = function() {
	return com.inq.stage.ViewportMgrImplPhoneAndroid.chatWindowZoomLevel;
};

/**
 * @overwrite
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.RestoreViewport = function() {
	com.inq.stage.ViewportMgrImplPhone.prototype.RestoreViewport.call(this);
	try {
		com.inq.ui.Container._getElementById("inqDivResizeCorner",parent.document).style.display = "none";
	} catch (ex) { 	}
};



/**
 * fixPositioning
 *
 * $type TFun([],TEnum(Void,[]))
 * @override
 * @private
 * @this com.inq.stage.ViewportMgrImplPhone
 * @return {void}
 */
com.inq.stage.ViewportMgrImplPhoneAndroid.prototype.fixPositioning = function() {
	com.inq.stage.ViewportMgrImplMobile.prototype.fixPositioning.call(this);

	/* We want to hide the location bar on phones
	 * So we must increase the minimum height to gaurantee
	 *   that we can scroll down one pixel to hide the location bar
	 */
	if (this.clientWindow.pageYOffset == 0)
		this.clientWindow.scrollTo(this.clientWindow.pageXOffset, 1);

};

